module.exports = __webpack_public_path__ + "c12451e0.png";